/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import axios from "axios";
import React, {useEffect, useState} from 'react';
import useToggle from '../../hook/ToggleHook'
import {useQuery} from "@tanstack/react-query";
import {useRegion} from "../../context/RegionContext";


const HeaderUtilServiceComponent = () => {
    // const region = 'global';  //global or china
    const [refresh, setRefresh] = useState(0);
    const {region, url} = useRegion();
    const lang = 'en';
    const app_info_path = `/cloud_app/app_info.json`
    const { status, data, error, isFetching } = useQuery({
        queryKey: [`app_info`, app_info_path, refresh],
        queryFn: async () => {
            const app_list = await axios.get(`${window._env_.REACT_APP_CDN_URL}${app_info_path}`);
            return app_list.data.apps.map(app=>{
                app.icon_url = `${window._env_.REACT_APP_CDN_URL}/cloud_app${app.icon.normal}`;
                app.website_url = app.website[region.toLowerCase()];
                app.display_name = app.name[lang];
                app.description = app.description[lang];
                return app;
            });
        }
    });
    const [open, node] = useToggle();

    useEffect(()=>{
        setRefresh(prev=>prev+1);
    }, [region]);

    return (
        <div className="util-btn util-service" ref={node}>
            <div className={"comp-dropdown " + open}>
                <ul className="comp-dropdown-menu dropdown-menu--services-grid">
                {/* add item components here */}
                    {data && data.map((app, index)=>(
                        <li className="services-grid__item" key={`app-${index}`} onClick={()=>window.open(app.website_url, '_blank')}>
                            <div className="services-grid__item__icon">
                                <img src={app.icon_url} alt={''} />
                            </div>
                            <div className="services-grid__item__label">{app.display_name}</div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default HeaderUtilServiceComponent;